import {ReactNode} from "react";

export type InfoType = 'primary' | 'secondary' | 'success' | 'danger' | 'xdanger' | 'warning' | 'info' | 'light' | 'dark' | 'link' | 'custom';
export type BadgeStyle = { bg: string, text: string };
export const badgeStyle: Record<InfoType, BadgeStyle> = {
    info: {bg: "bg-gray-100", text: "text-gray-800"},
    danger: {bg: "bg-red-100", text: "text-red-800"},
    xdanger: {bg: "bg-red-600", text: "text-white"},
    warning: {bg: "bg-yellow-100", text: "text-yellow-800"},
    success: {bg: "bg-green-100", text: "text-green-800"},
    primary: {bg: "bg-blue-100", text: "text-blue-800"},
    secondary: {bg: "bg-indigo-100", text: "text-indigo-800"},
    light: {bg: "bg-purple-100", text: "text-purple-800"},
    dark: {bg: "bg-pink-100", text: "text-pink-800"},
    link: {bg: "bg-blue-100", text: "text-blue-800"},
    custom: {bg: "", text: ""},
};
const BasicBadge: React.FC<{ label: string | ReactNode, type: InfoType, containerClass?: string, customStyle?: BadgeStyle, as?: 'div' | 'span' }> = ({
                                                                                                                                                         label,
                                                                                                                                                         type,
                                                                                                                                                         containerClass = 'text-xs',
                                                                                                                                                         customStyle = badgeStyle[type],
                                                                                                                                                         as = 'span'
                                                                                                                                                     }) => {
    const style = customStyle.bg.indexOf('#') === 0 ? {backgroundColor: customStyle.bg} : {};
    const bgClass = customStyle.bg.indexOf('bg-') === 0 ? customStyle.bg : '';
    return <>
        {as === 'span' &&
            <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 ${bgClass} ${containerClass} font-medium ${customStyle.text}`} style={style}>
                {label}
            </span>
        }
        {as === 'div' &&
            <div className={`rounded-full px-2.5 py-0.5 ${bgClass} ${containerClass} font-medium ${customStyle.text}`} style={style}>
                {label}
            </div>
        }
    </>
}
export default BasicBadge;
